import { Box, HStack } from "@chakra-ui/react";
import { FeedCardBarSegment } from "src/components/feed-card/content-blocks/bars/feed-card-bar-segment";
import { TFeedCardBarsBody, TFeedCardBarSegment } from "src/components/feed-card/types/content";

const calculateSegmentsWithPercentageValues = (segments: ReadonlyArray<TFeedCardBarSegment>): ReadonlyArray<TFeedCardBarSegment> => {
    const summary = segments.reduce((partialSummary, segment) => partialSummary + segment.value, 0);

    return segments.map(segment => ({
        ...segment,
        value: (segment.value / summary) * 100,
    }));
};

interface IFeedCardBar {
    segments: TFeedCardBarsBody;
}

export const FeedCardBars = ({ segments }: IFeedCardBar) => {
    const calculatedSegments = calculateSegmentsWithPercentageValues(segments);

    return (
        <Box>
            <Box w="100%" h={3} pb={0.5}>
                {calculatedSegments.map((segment, index) => (
                    <FeedCardBarSegment key={index} {...segment} />
                ))}
            </Box>
            <HStack justifyContent="space-between">
                {calculatedSegments.map(({ label }, index) => (
                    <Box key={index}>{label}</Box>
                ))}
            </HStack>
        </Box>
    );
};
